import React, { Fragment } from 'react';

import Backdrop from '../Backdrop/Backdrop';
import Modal from '../Modal/Modal';

const errorHandler = (props) => (
  <Fragment>
    {props.error && <Backdrop onClick={props.onHandle} />}
    {props.error && (
      <Modal
        title="خطایی رخ داده"
        onCancelModal={props.onHandle}
        onAcceptModal={props.onHandle}
        acceptEnabled
        acceptMessage={props.acceptMessage}
        cancelMessage={props.cancelMessage}
      >
        <p>{props.error.message}</p>
      </Modal>
    )}
  </Fragment>
); 

export default errorHandler;
